import api from '../../../services/api';

const login = async (username, password) => {
  const response = await api.post('/auth/login', {
    username,
    password,
  });

  const result = response.data;
  const { token, user } = result.data || {};

  if (
    !result.success ||
    !token ||
    !user ||
    !['super_admin', 'distributor'].includes(user.role)
  ) {
    throw new Error('Invalid login response from server.');
  }

  if (
    (user.role === 'super_admin' && user.firm_id != null) ||
    (user.role === 'distributor' && user.firm_id == null)
  ) {
    throw new Error('Invalid user account information.');
  }

  return { token, user };
};

const authService = { login };

export default authService;